import { SyncOutlined } from '@ifood/pomodoro-icons';
import tokens from '@ifood/pomodoro-tokens';
import { useIntl } from 'gatsby-plugin-intl';
import debounce from 'lodash.debounce';
import React, { FC, useMemo } from 'react';

import { DEBOUNCE_VALUE } from 'modules/UI';

import { Button } from './styles';

type UpdateButtonProps = {
  isLoading?: boolean;
  buttonTitleIntlKey?: string;
  debounceValue?: number;
  fn: () => void;
};

export const UpdateButton: FC<UpdateButtonProps> = ({
  isLoading = false,
  buttonTitleIntlKey = 'update',
  debounceValue = DEBOUNCE_VALUE,
  fn,
}) => {
  const { formatMessage } = useIntl();
  const debouncedReloadHandler = useMemo(() => debounce(fn, debounceValue), []);

  return (
    <Button
      disabled={isLoading}
      onClick={debouncedReloadHandler}
      title={formatMessage({ id: buttonTitleIntlKey })}
      ml={tokens.space.smallest}
      type="button"
    >
      <SyncOutlined />
    </Button>
  );
};
